import { atom } from "jotai";

/** Whether the left sidebar overlay is open (mobile navigation). */
export const leftSidebarOpenAtom = atom(false);

export const openLeftSidebarAtom = atom(null, (_get, set) => {
  set(leftSidebarOpenAtom, true);
});

export const closeLeftSidebarAtom = atom(null, (_get, set) => {
  set(leftSidebarOpenAtom, false);
});

export const toggleLeftSidebarAtom = atom(null, (get, set) => {
  set(leftSidebarOpenAtom, !get(leftSidebarOpenAtom));
});
